module.exports = __webpack_public_path__ + "img/laohuang_des_2.5008f5a8.jpg";